import React from 'react';
import {Box, Flex, Center, Button, Image, Divider, Heading, Text, useToast, Icon} from '@chakra-ui/react';
import GaiLogo from '../../images/logo_300x129_transparent.png';
import FlexCard from '../../components/General/FlexCard';
import {useForm} from 'react-hook-form';
import {CustomInput} from '../../components/General/FormInputs';
import {FaCheck, FaRedo, FaUser, FaUserCheck} from 'react-icons/fa';
import {User} from '../../service/Urls';
import {postNoAuth} from '../../service/ApiService';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {IoCheckmark, IoClose} from 'react-icons/io5';

const ResetPassword = ({unlock}) => {
  const toast = useToast();
  const navigate = useNavigate();
  const [queryParams, setQueryParams] = useSearchParams();
  const {
    register,
    handleSubmit,
    watch,
    formState: {errors},
  } = useForm();

  const password = watch('password1') ?? '';

  const onSubmit = async data => {
    if (data.password1 != data.password2) {
      toast({
        title: 'Error',
        description: 'Entered passwords do not match',
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
      return;
    }

    const requestData = {
      userName: queryParams.get('user'),
      userId: queryParams.get('user'),
      token: queryParams.get('token'),
      password: data.password1,
    };

    // const unlockData = {
    //   userName: queryParams.get('user'),
    //   token: queryParams.get('token'),
    //   password: data.password1,
    // };

    const endpoint = unlock ? User.UNLOCK : User.RESET_PWD;
    // const requestData = unlock ? unlockData : resetData;
    const userRequest = await postNoAuth(endpoint, requestData);

    if (userRequest?.error) {
      let errorMessage = userRequest.error;
      if (errorMessage.toLowerCase().includes('invalid token')) {
        errorMessage = 'Your link is invalid. Please request a new link.';
      }

      toast({
        title: 'Error',
        description: errorMessage,
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
      return;
    } else {
      const message = unlock ? 'Account Created' : 'Password Reset';
      toast({
        title: 'Success',
        description: message,
        status: 'success',
        duration: 9000,
        isClosable: true,
      });
      setTimeout(() => {
        navigate('/login', {replace: true});
      }, 2000);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Center mt="12">
        <FlexCard>
          <Flex justifyContent={'center'} mx="12">
            <Box>
              <Image mx={'30'} my="3" src={GaiLogo} maxW={{base: 'md', md: 'sm'}} />
              <Flex justifyContent={'center'}>
                <Heading>{unlock ? 'Register Account' : 'Reset Password'}</Heading>
              </Flex>
              <Divider my="5" />
              <Box p={5} backgroundColor={'secondary.100'} borderRadius={5}>
                <Text fontSize={20} mb={3} textAlign="center">
                  Password Must
                </Text>
                <PasswordRequirement isMet={password.length >= 6} message={'Be at least 6 characters in length'} />
                <PasswordRequirement isMet={/\d/.test(password)} message={'Contain a digit'} />
                <PasswordRequirement isMet={/[a-z]/.test(password)} message={'Contain a lowercase letter'} />
                <PasswordRequirement isMet={/[A-Z]/.test(password)} message={'Contain an uppercase letter'} />
                <PasswordRequirement
                  isMet={/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password)}
                  message={'Contain a special character (e.g. !@#$%^&*)'}
                />
              </Box>
              <Box my="4">
                <CustomInput
                  id="password1"
                  name={unlock ? 'Password' : 'New Password'}
                  register={register}
                  errors={errors}
                  required
                  isPassword
                ></CustomInput>
              </Box>
              <Box my="4">
                <CustomInput
                  id="password2"
                  name={unlock ? 'Confirm Password' : 'Confirm New Password'}
                  register={register}
                  errors={errors}
                  required
                  isPassword
                ></CustomInput>
              </Box>
              <Button type="submit" w="100%" colorScheme="teal" leftIcon={unlock ? <FaUserCheck /> : <FaRedo />} my="5">
                {unlock ? 'Register' : 'Reset'}
              </Button>
            </Box>
          </Flex>
        </FlexCard>
      </Center>
    </form>
  );
};

const PasswordRequirement = ({isMet, message}) => {
  return (
    <Flex gap={3}>
      <Icon as={isMet ? IoCheckmark : IoClose} fontSize={20} fontWeight={'bold'} color={isMet ? 'green' : 'red.500'} />
      <Text ml={2} fontSize={16}>
        {' '}
        {message}
      </Text>
    </Flex>
  );
};
export default ResetPassword;
// @param {id, name, register, errors, required=false}
